"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecretViewModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _commonUtils = require("../../../../../../../utils/common-utils");

var _constants = require("../constants");

var _SecretViewDetails = require("./SecretViewDetails");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecretViewModal = function SecretViewModal(_ref) {
  var secretDetailStatus = _ref.secretDetailStatus,
      secretTemplateDetailStatus = _ref.secretTemplateDetailStatus,
      secretDetailData = _ref.secretDetailData,
      secretTemplateData = _ref.secretTemplateData,
      secretViewActionButtons = _ref.secretViewActionButtons,
      secretViewName = _ref.secretViewName,
      onCloseHandler = _ref.onCloseHandler,
      file = _ref.file,
      secretFileDownloadStatus = _ref.secretFileDownloadStatus,
      secretFileDownloadStatusCode = _ref.secretFileDownloadStatusCode,
      reloadSecretFile = _ref.reloadSecretFile,
      fetchNewOTP = _ref.fetchNewOTP,
      otp = _ref.otp,
      secretOTPFetchStatus = _ref.secretOTPFetchStatus,
      secretOTPFetchError = _ref.secretOTPFetchError,
      selectedItemAncestors = _ref.selectedItemAncestors,
      secretDetailsLoadTime = _ref.secretDetailsLoadTime,
      secretTemplateLoadTime = _ref.secretTemplateLoadTime,
      secretOTPFetchLoadTime = _ref.secretOTPFetchLoadTime;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((0, _commonUtils.isLoading)(secretDetailStatus) || (0, _commonUtils.isLoading)(secretTemplateDetailStatus)) && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretViewLoader
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: _constants.secretListConstants.mediumSize,
    message: _constants.translatedStrings.secretDetailLoadingMessage
  })), !(0, _commonUtils.isLoading)(secretDetailStatus) && /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: _constants.secretListConstants.secretViewModalWidth,
    title: secretViewName,
    buttons: secretViewActionButtons,
    onCancel: onCloseHandler
  }, (0, _commonUtils.isSuccess)(secretDetailStatus) && (0, _commonUtils.isSuccess)(secretTemplateDetailStatus) && /*#__PURE__*/_react.default.createElement(_SecretViewDetails.SecretViewDetails, {
    secretDetailData: secretDetailData,
    secretTemplateData: secretTemplateData,
    file: file,
    secretFileDownloadStatus: secretFileDownloadStatus,
    secretFileDownloadStatusCode: secretFileDownloadStatusCode,
    reloadSecretFile: reloadSecretFile,
    fetchNewOTP: fetchNewOTP,
    otp: otp,
    secretOTPFetchStatus: secretOTPFetchStatus,
    secretOTPFetchError: secretOTPFetchError,
    selectedItemAncestors: selectedItemAncestors,
    secretDetailsLoadTime: secretDetailsLoadTime,
    secretTemplateLoadTime: secretTemplateLoadTime,
    secretOTPFetchLoadTime: secretOTPFetchLoadTime
  })));
};

exports.SecretViewModal = SecretViewModal;
SecretViewModal.propTypes = {
  secretDetailStatus: _propTypes.default.string,
  secretTemplateDetailStatus: _propTypes.default.string,
  secretDetailData: _propTypes.default.object,
  secretTemplateData: _propTypes.default.object,
  secretViewActionButtons: _propTypes.default.object,
  onCloseHandler: _propTypes.default.func,
  secretViewName: _propTypes.default.string,
  file: _propTypes.default.object,
  secretFileDownloadStatus: _propTypes.default.string,
  secretFileDownloadStatusCode: _propTypes.default.number,
  reloadSecretFile: _propTypes.default.func,
  fetchNewOTP: _propTypes.default.func,
  otp: _propTypes.default.string,
  secretOTPFetchStatus: _propTypes.default.string,
  secretOTPFetchError: _propTypes.default.string,
  selectedItemAncestors: _propTypes.default.array,
  secretDetailsLoadTime: _propTypes.default.number,
  secretTemplateLoadTime: _propTypes.default.number,
  secretOTPFetchLoadTime: _propTypes.default.number
};